import { AxiosResponse } from 'axios'

import base from './base'

export const getAll = (): Promise<AxiosResponse<any>> => {
  return base.get('/v1/master_data')
}
